export const OutlookMailHowItWorks: React.FC = () => {
  return (
    <div>
      Connect your accounts to easily drafts and send emails through your Outlook account. Leverage client emails for meeting prep and insights, capture more
      tasks, and get answers to client-related questions in seconds from your Outlook. Automate inbound and outbound emails with Zocks Ultimate. Get the full
      functionality of Zocks with our Native App directly in Outlook, so you never have to switch tabs or navigate multiple systems.
    </div>
  )
}
